import apiClient from "../../api/api";
import { API_ENDPOINTS } from "../../api/api.config";

export interface GmailCredential {
    _id: string;
    user_info: {
        user_email: string;
        user_name: string;
    };
    id: string;
}

const gmailService = {
    getGmailLoginUrl: (templateId?: string) => {
        const baseUrl = `${import.meta.env.VITE_DMS_API}${API_ENDPOINTS.GOOGLE_CONNECTOR.LOGIN}`;
        return templateId ? `${baseUrl}?template_id=${templateId}` : baseUrl;
    },

    listCredentials: async (templateId?: string | null) => {
        try {
            const response = await apiClient.get(
                API_ENDPOINTS.GOOGLE_CONNECTOR.LIST_CREDENTIALS,
                {
                    params: { template_id: templateId }
                }
            );
            return response.data;
        } catch (error: any) {
            console.error("Error listing Gmail credentials:", error);
            throw error;
        }
    },

    generateTemplate: async (prompt: string, variables?: string[]) => {
        try {
            const response = await apiClient.post(
                API_ENDPOINTS.GOOGLE_CONNECTOR.GENERATE_TEMPLATE,
                { prompt, variables }
            );
            return response.data;
        } catch (error: any) {
            console.error("Error generating template:", error);
            throw error;
        }
    },

    previewStandard: async (data: any) => {
        try {
            const response = await apiClient.post(
                API_ENDPOINTS.GOOGLE_CONNECTOR.PREVIEW_STANDARD,
                { data }
            );
            return response.data;
        } catch (error: any) {
            console.error("Error previewing standard template:", error);
            throw error;
        }
    },
};

export default gmailService;
